import styled from "styled-components";

export const ModalBackdrop = styled("div")(({ open }) => {
  return {
    display: open ? "block" : "none",
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    zIndex: 999,
    backdropFilter: "blur(4px)",
    WebkitBackdropFilter: "blur(4px)",
    pointerEvents: open ? "auto" : "none",
  };
});

export const BaseModalWrapper = styled("div")(({
  open,
  height,
  width,
  top,
  left,
  right,
}) => {
  return {
    display: open ? "block" : "none",
    position: "fixed",
    top: top !== undefined ? top : "50%",
    left: left !== undefined ? left : "50%",
    right,
    transform:
      top === undefined && left === undefined
        ? "translate(-50%, -50%)"
        : undefined,
    zIndex: 1000,
    overflowY: "auto",
    maxHeight: "90vh",
    height: height || "auto",
    width: width || "50%",
    pointerEvents: "auto",
    backgroundColor: "transparent",
  };
});
